var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartRow"},[_c('div',{staticClass:"chartCol"},[_c('div',{style:({width: '96%', height: '360px'}),attrs:{"id":"barLeftChart"}})]),_vm._v(" "),_c('div',{staticClass:"chartCol"},[_c('div',{style:({width: '96%', height: '360px'}),attrs:{"id":"barRightChart"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-650fb694","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bipage/components/BarChart.vue
// module id = null
// module chunks = 